import LoginForm from '../components/Auth/LoginForm';

const LoginPage = () => {
  return <LoginForm />;
};

export default LoginPage;



